import './polyfills'

import { loadConfig } from 'settings'
import { ensureUnpartitionedStorageAccessIfNeeded } from 'app/ui/EmbeddedStorageAccess'
import { isInIframe, isInSandboxedIframe } from 'app/utils/embedding'
import { preloadWorkerScriptsAsBlobs } from './features/common/utils/deckGlWorkers'
import { patchRequestScheduler } from './features/builder/utils/standalone-request-scheduler-patch'

const boostrapApp = async () => {
  await loadConfig()

  const isViewer = window.location.pathname.startsWith('/viewer')
  const isOldViewerIframeAuthenticationMethod =
    isViewer && !window.location.search.includes('use-external-access-token')

  const needsUnpartitionedStorageAccess = isInIframe && isOldViewerIframeAuthenticationMethod
  if (needsUnpartitionedStorageAccess) {
    // Must run before ReactApp loads, as it swaps window.localStorage before Auth0 reads its session.
    await ensureUnpartitionedStorageAccessIfNeeded()
  }

  if (isInSandboxedIframe()) {
    await preloadWorkerScriptsAsBlobs()
  }

  // Apply RequestScheduler and Tileset2D patches before React app loads
  // TODO: Remove once loaders.gl 4.4 is released with native setProps() support
  patchRequestScheduler()

  const { renderApp } = await import('./ReactApp')
  renderApp()
}

boostrapApp()
